import { useNavigate, useSearchParams } from 'react-router-dom';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

import { useAuthStore } from '@/store/authStore';
import { useT } from '@/i18n';
import LanguageSwitch from '@/components/common/LanguageSwitch';
import type { LoginRequest } from '@/types';

const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useT();
  const { login, isLoading, error, clearError } = useAuthStore();
  const [form] = Form.useForm();

  const onFinish = async (values: LoginRequest) => {
    try {
      await login(values);
      message.success(t('登录成功'));

      // 获取重定向路径，如果没有则跳转到首页
      const redirectPath = searchParams.get('redirect') || '/';
      navigate(redirectPath);
    } catch {
      // Error is handled by the store
    }
  };

  return (
    <div className="relative flex items-center justify-center min-h-screen bg-gray-100">
      <div className="absolute top-4 right-4">
        <LanguageSwitch compact />
      </div>
      <Card className="w-full max-w-md shadow-lg">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold">{t('底软包交付管理系统')}</h1>
          <p className="text-gray-500 mt-2">BSP Package Delivery Management</p>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded text-red-600">
            {t(error)}
            <button
              className="float-right text-red-400 hover:text-red-600"
              onClick={clearError}
            >
              ×
            </button>
          </div>
        )}

        <Form form={form} onFinish={onFinish} layout="vertical" size="large">
          <Form.Item
            name="username"
            rules={[{ required: true, message: t('请输入用户名') }]}
          >
            <Input prefix={<UserOutlined />} placeholder={t('用户名')} />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: t('请输入密码') }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder={t('密码')} />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={isLoading} block>
              {t('登录')}
            </Button>
          </Form.Item>
        </Form>

        <div className="text-center text-gray-400 text-sm">
          {t('内部用户请使用企业账号登录')}
        </div>
      </Card>
    </div>
  );
};

export default Login;
